/**
 * Shared find-bar chrome for edit + preview.
 * Fixed chip size so preview abspos cannot stretch a shadcn `w-full` input.
 * Height/width sit between the cramped edit field and the oversized preview pill.
 */
export const FIND_BAR_CHIP_CLASS =
  'flex h-8 w-72 shrink-0 items-center gap-1 px-2 rounded-md border border-border bg-popover text-popover-foreground shadow-md'

export const FIND_BAR_ICON_BUTTON_CLASS = 'size-6 shrink-0'

export const FIND_BAR_INPUT_CLASS =
  'h-7 min-w-0 flex-1 bg-transparent border-0 p-0 text-sm leading-5 outline-none shadow-none placeholder:text-muted-foreground/40'

/** Focus the find field and select the current query so Cmd+F can edit it. */
export function focusAndSelectFindInput(input: HTMLInputElement | null | undefined): boolean {
  if (!input) return false
  input.focus()
  const value = input.value ?? ''
  if (value.length > 0) {
    input.setSelectionRange(0, value.length)
  }
  return true
}
